import React from 'react';
import { Button, FormInput, FormSelect } from '@ihsm/ui-shared';
import { TransparentButton } from 'shared/components/Buttons';
import { portfolioOptionsRunReport } from 'state/store/selectors';
import { Modal } from 'shared/components/modal';
import { useAppSelector } from 'state/store';
import { RunReportForm } from '../types';
import { RunReportPortfoliosList } from './RunReportPortfoliosList';
import './RunReportModalForm.scss';

interface RunReportModalFormProps {
  onRun: () => void;
  onCancel: () => void;
  form: RunReportForm;
  setForm?: (form: RunReportForm) => void;
  isLoading?: boolean;
  isVisible: boolean;
  setVisible: (visibility: boolean) => void;
}

export const RunReportModalForm: React.FC<RunReportModalFormProps> = ({
  form,
  onRun = () => {},
  onCancel = () => {},
  setForm = () => {},
  isLoading = false,
  isVisible,
  setVisible,
}) => {
  const options = portfolioOptionsRunReport(useAppSelector((state) => state));
  const { contexts } = useAppSelector((state) => state.contextsState);
  const { portfolios: currentPortfolios, valuationDate, name } = form;

  return (
    <Modal
      isVisible={isVisible}
      setVisibility={setVisible}
      modalSize={{ width: 950, height: 600 }}
      header={
        <div className="run-report-modal-form__header">
          <div className="run-report-modal-form__header-label">Run Report</div>
          <div className="run-report-modal-form__header-title">{name}</div>
        </div>
      }
    >
      <div className="run-report-modal-form">
        <div className="run-report-modal-form__options">
          <FormInput
            type="date"
            label="As of Date"
            value={valuationDate}
            disabled={isLoading}
            onChange={(e) =>
              setForm({ ...form, valuationDate: e.target.value })
            }
          />

          <FormSelect
            label="Context"
            value="Official"
            options={contexts}
            disabled={isLoading}
            onChange={() => {}}
          />
        </div>

        <div className="run-report-modal-form__list">
          <RunReportPortfoliosList
            data={currentPortfolios || []}
            options={options}
            onDataChange={(portfolios) => setForm({ ...form, portfolios })}
            isDisabled={isLoading}
          />
        </div>

        <div className="run-report-modal-form__buttons">
          <TransparentButton text="Cancel" onClick={onCancel} />
          <Button text="Run Report" onClick={onRun} disabled={isLoading} />
        </div>
      </div>
    </Modal>
  );
};
